/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Limit_Reached_TitleInputs */



/**
* | output |
* | --- |
* | "Member limit reached" |
*
* @param {Members_Limit_Reached_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_limit_reached_title = /** @type {((inputs?: Members_Limit_Reached_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Limit_Reached_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitgliederlimit erreicht")
	return /** @type {LocalizedString} */ ("Member limit reached")
});